import { profileRoute } from './profile/profile'
import { bazaryab_adminRoute } from './bazaryab-admin/bazaryab-admin'
import { store_admin_route } from './store-admin/store-admin-route'
import { logisticRoute } from './logistic/logistic-route'


export let appRoute = []

appRoute = appRoute.concat(profileRoute, bazaryab_adminRoute, store_admin_route, logisticRoute)



// WEBPACK FOOTER //
// ./src/store-modules/app/route/route.ts